(function() {

    var html = `
    <ul>
        <li class="investigations-link"><a href="http://www.realclearinvestigations.com/">Investigations</a></li>
        <li class="politics-link"><a href="http://www.realclearpolitics.com/">Politics</a></li>
        <li class="policy-link"><a href="http://www.realclearpolicy.com/">Policy</a></li>
        <li class="markets-link"><a href="http://www.realclearmarkets.com/">Markets</a></li>
        <li class="world-link"><a href="http://www.realclearworld.com/">World</a></li>
        <li class="defense-link"><a href="http://www.realcleardefense.com/">Defense</a></li>             
        <li class="energy-link"><a href="http://www.realclearenergy.org">Energy</a></li>
        <li class="health-link"><a href="http://www.realclearhealth.com">Health</a></li>
        <li class="science-link"><a href="http://www.realclearscience.com/">Science</a></li>
        <li class="religion-link"><a href="http://www.realclearreligion.org/">Religion</a></li>
        <li class="education-link"><a href="http://www.realcleareducation.com">Education</a></li>      
        <li class="history-link"><a href="http://www.realclearhistory.com/">History</a></li>
        <li class="books-link"><a href="http://www.realclearbooks.com/">Books & Culture</a></li>
        <li class="florida-link"><a href="http://www.realclearflorida.com/">Florida</a></li>
        <li class="pennsylvania-link"><a href="http://www.realclearpennsylvania.com/">Pennsylvania</a></li>     
        <li class="life-link"><a href="https://www.insidehook.com/realclearlife-by-insidehook">Life</a></li>
    </ul>
    `;

    //<li class="sports-link"><a href="https://www.insidehook.com/category/sections/sports">Sports</a></li>
    //<li class="publishing-link"><a href="http://www.realclearpolitics.com/realclearpublishing/">Publishing</a></li>
    // Replace HTML content of all matching targets with above
    var containers = document.querySelectorAll('.masthead_sites_nav');
    if(containers.length > 0) {
        for(var i = 0; i < containers.length; i++) {
            containers[i].innerHTML = html;
        }
    }

})();